import { useDispatch } from 'react-redux';
import { closeModal, closeModalAbout } from '../../redux/modalSlice';
import { globals } from '../Globals/Globals';
import './Modal.css';

const About = () => {
  const dispatch = useDispatch();
  return (
    <aside className='custom-modal-container'>
      <div className='custom-modal'>
        <div className='custom-modal-title'><h1>Version {globals.menu.version.release}</h1></div>
        <h3>Nouveautés</h3>
        <ol>
        {globals.menu.version.whatisnew.map((updates)=>{
          return (<li>{updates.title}</li>)
        })}
        </ol>
        <div className='custom-btn-container'>
          <button
            type='button'
            className='btn clear-btn'
            onClick={() => {
              dispatch(closeModalAbout());
            }}
          >
            Ok
          </button>
        </div>
      </div>
    </aside>
  );
};
export default About;
